import React from 'react';
import Header from "../../User/layouts/Header";
import "../styles/pages/home.scss";
import { Typography, Container } from '@mui/material';
import WhatsApp from "../../User/components/WhatsApp";
import Footer from '../layouts/Footer';

const Contactus = () => {
    return (
        <React.Fragment>
            <Header />
            <section className='about'>
                <Typography variant='h4'>Contact Us</Typography>
            </section>
            <section className='faq'>
                <Container maxWidth="xl">
                    <div class="privacy-content-1">
                        <Typography><span>Email :</span> tailors4u2025@gmail.com</Typography>
                        <Typography><span>Contact :</span> +91 9036074200</Typography>
                        <Typography><span>Address :</span> ARYADITYA FASHIONS (OPC) PRIVATE LIMITED
                            FLAT-1301, C BLK GOLF, VIEW APT, NANAKRAMGUDA, Gachibowli, Seri Lingampally, K.V.Rangareddy- 500032,
                            Telangana</Typography>
                    </div>
                </Container>
            </section>
            <WhatsApp />
            <React.Fragment>
                <Footer />
            </React.Fragment>
        </React.Fragment>
    )
}

export default Contactus;